import React from "react";
import Styles from "./SyllabusComponent.module.css";
import PlainInput from "../Editor/PlainInput";
import TopicSelector from "../../../components/molecules/TopicSelector/TopicSelector";

// need to add loader for vin messages and section subject tree loading

const SyllabusComponent = (props) => {
  const editor = () => {
    return <PlainInput isDisable={true} buttons={[]} />;
  };
  // console.log("PROPS", props);
  return (
    <div className={Styles.mainContainer}>
      <div className={Styles.syllabus}>
        <div className={Styles.syllabusSubComponent}>
          <TopicSelector
            openFull={true}
            unlockProps={props?.unlockProps}
            subject={props?.subject}
            subjectMasterUuid={props?.subjectMasterUuid}
            topic={props?.topicName}
            topicMasterUuid={props?.topicMasterUuid}
            subjectName={props?.subjectName}
            topicName={props?.topicName} />

        </div>
      </div>
      <div className={Styles.bottomContainer}>
        <div className={Styles.bottomEditor}>{editor()}</div>
        <div className={Styles.bottomBox} />
      </div>
    </div>);

};

export default SyllabusComponent;